import styled from 'styled-components';
import { Container } from '@miro-site/core';
var HeaderContainer = styled(Container).attrs(function (_ref) {
  var theme = _ref.theme;
  return {
    as: 'div',
    $px: theme.header.container.horizontalPadding,
    $styles: {
      maxWidth: theme.header.container.maxWidth
    }
  };
}).withConfig({
  displayName: "HeaderContainer",
  componentId: "sc-19f6gc6-0"
})([""]);
HeaderContainer.displayName = 'HeaderContainer';
export default HeaderContainer;